import {
	BaseModal,
	Box,
	Button,
	ComposedElement,
	Overlay,
	Typography,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Lightning, Close } from '@bcp-nextgen-dx-component-factory/icons-foundation';

import { useUserIsClientHelper } from './userIsClient.helper';

export const UserIsClientAbModal: React.FC = () => {
	const { handleOnClickClose, handleYesButton, handleClickGetInTouch, isVisible, currentView, translate } =
		useUserIsClientHelper();
	const { colorPalette } = useTheme();

	const styles = {
		smallView: {
			mainBox: {
				minWidth: '343px',
			},
		},
		tabletView: {
			mainBox: {
				minWidth: '456px',
			},
		},
		bigView: {
			mainBox: {
				minWidth: '600px',
			},
		},
	};

	return (
		<BaseModal visible={isVisible} externalBackdrop={<Overlay onPress={handleOnClickClose} />}>
			<Box
				styles={{
					...styles[currentView].mainBox,
					background: 'white',
					flexDirection: 'column',
					padding: '0 32px 32px',
					borderRadius: '16px',
				}}
			>
				<Box styles={{ justifyContent: 'center' }}>
					<Box
						styles={{
							background: colorPalette.color_02[100],
							width: '64px',
							height: '64px',
							justifyContent: 'center',
							borderRadius: '32px',
							margin: '-32px 0 24px',
							border: '4px solid white',
						}}
					>
						<ComposedElement
							icon={{ source: Lightning.Outline, svgProps: { fill: 'white' } }}
							size="small"
						/>
					</Box>
				</Box>

				<Box
					styles={{
						alignSelf: 'end',
						margin: '-24px 0 24px',
					}}
					onPress={handleOnClickClose}
				>
					<ComposedElement
						container={{
							styles: {
								background: colorPalette.color_01[70],
							},
						}}
						fill={colorPalette.color_01[100]}
						icon={{
							source: Close.Outline,
						}}
					/>
				</Box>

				<Box styles={{ marginBottom: '32px', justifyContent: 'center' }}>
					<Typography appearance="body-200-04">{translate('simulator.modals.userIsClient.title')}</Typography>
				</Box>

				<Box styles={{ flexDirection: 'column', rowGap: '20px' }}>
					<Box>
						<Button fullWidth onPress={handleYesButton}>
							{translate('simulator.modals.userIsClient.button1')}
						</Button>
					</Box>
					<Box>
						<Button fullWidth appearance="outline" onPress={handleClickGetInTouch}>
							{translate('simulator.modals.userIsClient.button2')}
						</Button>
					</Box>
				</Box>
			</Box>
		</BaseModal>
	);
};
